import React from 'react';
import './About.css';

const REGISTER_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSfhWIwZ8VQ4MP3e1Z2X9VyuHoOj_sNSbSUFVPoNm5_MeF6ytQ/viewform';

const About = () => {
    return (
        <div id='about' className="about-section">
            <a
                className="register-btn about-register-btn"
                href={REGISTER_FORM_URL}
                target="_blank"
                rel="noopener noreferrer"
            >
                Register Now
            </a>
            <h2 className="about-title">About the Symposium</h2>
            <p className="about-description">
                The New York City Department of Transportation (NYCDOT) and Federal
                Highway Administration (FHWA), supported by organizers at New York
                University's C2SMART Center, and the City College of New York's
                University Transportation Research Center, is seeking to convene
                industry professionals, public agencies, researchers, and roadway
                users for a symposium focused on the future deployment of Artificial
                Intelligence (AI) applications in urban transportation management.
            </p>
            <h3 className="about-subtitle">Goals of the symposium</h3>
            <ul className="about-goals">
                <li>
                    Facilitate discussion among transportation professionals,
                    researchers, technology experts, and members of the public.
                </li>
                <li>
                    Explore current challenges, emerging AI solutions, and pathways
                    for sustainable, scalable implementation.
                </li>
                <li>Examine international best practices and lessons learned.</li>
                <li>
                    Generate recommendations and follow-up analysis to help NYC DOT
                    and other agencies identify risks, deployment barriers, and
                    future research needs.
                </li>
            </ul>
        </div>
    );
};

export default About;
